module.exports = "/React/dist/6a9a764203e6abf5bbacd4a5861d0117.gif";